import { ComponentProps, FC } from 'react';
import { ClipLoader } from 'react-spinners';
import Button from '../Button/Button';

type ButtonWithIcon = {
  icon: string;
  iconAltText: string;
  iconPosition?: 'left' | 'right';
};
type ButtonWithoutIcon = {
  icon?: undefined;
  iconAltText?: undefined;
  iconPosition?: undefined;
};
export type OutlinedButtonProps = Omit<ComponentProps<typeof Button>, 'icon'> &
  (ButtonWithIcon | ButtonWithoutIcon) & {
    isLoading?: boolean;
    spinnerColor?: string;
    spinnerSize?: string;
  };

export const OutlinedButton: FC<OutlinedButtonProps> = ({
  icon,
  iconAltText,
  children,
  className,
  isLoading = false,
  type = 'button',
  spinnerColor = '#fff',
  spinnerSize,
  ...rest
}) => {
  const disabled = rest.disabled || isLoading;
  return (
    <Button
      icon={icon ? () => <img src={icon} alt={iconAltText} /> : undefined}
      className={[
        'flex items-center justify-center px-4 py-1.5 gap-2 bg-transparent h-8 text-primary-default border-2 border-solid border-primary-default [&_p]:flex [&_p]:items-center [&_p]:justify-center rounded-xl hover:bg-transparent',
        className,
      ].join(' ')}
      {...rest}
      type={type}
      disabled={disabled}
    >
      <span className={isLoading ? 'invisible' : 'visible'}>{children}</span>
      {isLoading ? (
        <ClipLoader
          className="absolute"
          color={spinnerColor}
          speedMultiplier={0.9}
          size={spinnerSize}
        />
      ) : null}
    </Button>
  );
};
